import { MapRecipe } from "../recipe";

// What a build gets instead of devMaps.ts (vite.config.ts)
export const SCAPERUNE_DEV_MAPS: MapRecipe[] = [];
